(() => {
  const debounce = (fn, wait = 150) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  function buildItem(title, url, image) {
    const img = image ? `<img src="${image}" alt="" loading="lazy">` : "";
    return `
      <a class="ps-item" href="${url}">
        ${img}
        <span class="ps-title">${title}</span>
      </a>
    `;
  }

  function initPredictiveSearch(form) {
    const input = form.querySelector(".js-ps-input");
    const dropdown = form.querySelector(".js-ps-dropdown");
    const resultsEl = form.querySelector(".js-ps-results");
    const psUrl = form.getAttribute("data-ps-url") || "/search/suggest";

    if (!input || !dropdown || !resultsEl) return;

    const close = () => {
      dropdown.hidden = true;
      input.setAttribute("aria-expanded", "false");
      resultsEl.innerHTML = "";
    };

    const open = () => {
      dropdown.hidden = false;
      input.setAttribute("aria-expanded", "true");
    };

    const fetchSuggestions = async (q) => {
      // products + collections (add/remove types as you want)
      const url =
        `${psUrl}.json?q=${encodeURIComponent(q)}` +
        `&resources[type]=product,collection` +
        `&resources[limit]=6` +
        `&resources[options][unavailable_products]=show`;

      const res = await fetch(url, { headers: { "Accept": "application/json" } });
      if (!res.ok) throw new Error("Predictive search failed");
      return res.json();
    };

    const render = (q, data) => {
      const products = data?.resources?.results?.products || [];
      const collections = data?.resources?.results?.collections || [];

      const items = [];

      products.forEach(p => {
        items.push(buildItem(p.title, p.url, p.image));
      });

      collections.forEach(c => {
        items.push(buildItem(`Collection: ${c.title}`, c.url, c.image));
      });

      // “Search for …” fallback
      items.push(
        `<a class="ps-item ps-item--search" href="/search?q=${encodeURIComponent(q)}">
          Search for “${q}”
        </a>`
      );

      resultsEl.innerHTML = items.join("");
      open();
    };

    const onInput = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) return close();

      try {
        const data = await fetchSuggestions(q);
        render(q, data);
      } catch (e) {
        // fail silently
        close();
      }
    }, 180);

    input.addEventListener("input", onInput);

    document.addEventListener("click", (e) => {
      if (!form.contains(e.target)) close();
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    input.addEventListener("focus", () => {
      // if already has results, open
      if (resultsEl.innerHTML.trim()) open();
    });
  }

  document.querySelectorAll("form[data-ps-url]").forEach(initPredictiveSearch);
})();
